import { getLocale, subscribeToLocale } from "./i18n/locale";
import { translate } from "./i18n/translate";

/** 브라우저 탭 제목을 현재 로케일에 맞추고 전환을 따라가게 한다. 해제 함수를 돌려준다. */
export function keepDocumentTitleLocalized(): () => void {
  applyDocumentTitle();
  return subscribeToLocale(applyDocumentTitle);
}

function applyDocumentTitle(): void {
  document.title = translate(getLocale(), "app.documentTitle");
}
